import * as Sentry from '@sentry/react';

import { isProductionEnvironment } from './env';

const getSentryEnvironment = () => {
  if (isProductionEnvironment()) {
    if (window.Cypress) {
      return 'production-cypress';
    }

    return 'production';
  }

  return 'local';
};

const sentryEnvironment = getSentryEnvironment();

Sentry.init({
  dsn: 'https://89f0812a288697aa10b410864643b916@o4505279470501888.ingest.us.sentry.io/4505716010385408',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1, // Capture 100% of the transactions, reduce in production!
  // replaysSessionSampleRate: 0.05, // This sets the sample rate at 5%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: sentryEnvironment,
  enabled: sentryEnvironment !== 'local',

  release: process.env.COMMIT_SHA ?? 'local-dev',
});
